import { Route, Routes } from 'react-router-dom'
import { PATH } from '~/AppRoutes'
import { useCurrentUser } from '~/common'
import {
  IntegratorAddPage,
  IntegratorDetailsPage,
  IntegratorEditPage,
  IntegratorsPage,
} from '~/modules/integrators/view'
import { AuthWrapped } from '~/modules/navigation/components'

export const IntegratorsRoutes = () => {
  const { hasRole } = useCurrentUser()
  const canAccess = hasRole('CCC')
  return (
    <Routes>
      <Route index element={<AuthWrapped component={IntegratorsPage} canAccess={canAccess} />} />
      <Route path={PATH.ADD} element={<AuthWrapped component={IntegratorAddPage} canAccess={canAccess} />} />
      <Route
        path={`${PATH.DETAILS}/:id`}
        element={<AuthWrapped component={IntegratorDetailsPage} canAccess={canAccess} />}
      />
      <Route path={`${PATH.EDIT}/:id`} element={<AuthWrapped component={IntegratorEditPage} canAccess={canAccess} />} />
    </Routes>
  )
}

export const integratorsLinks = {
  integratorsLink: () => PATH.OVERVIEW,
  integratorDetailsLink: (id: string) => `/${PATH.DETAILS}/${id}`,
  editIntegratorDetailsLink: (id: string) => `/${PATH.EDIT}/${id}`,
  integratorLink: () => `/${PATH.ADD}`,
}
